// Yoruba translations
export const yo: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Awọn alabara',
  'menu.products': 'Awọn ọja',
  'menu.users': 'Awọn olumulo',
  'menu.settings': 'Ètò',
  'menu.logout': 'Jade',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Aṣẹ Tuntun',
  'order.title': 'Aṣẹ Tuntun',
  'order.customer': 'Alabara',
  'order.products': 'Awọn ọja',
  'order.total': 'Lapapọ',
  'users.title': 'Awọn olumulo',
  'users.name': 'Orukọ',
  'users.email': 'Imeeli',
  'common.yes': 'Bẹẹni',
  'common.no': 'Rara',
  'common.cancel': 'Fagilee',
  'common.save': 'Fi pamọ',
  'common.search': 'Wa',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Wọle',
  'login.welcome': 'Kaabo, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imeeli',
  'signup.phone': 'Foonu',
  'menu.reportsAndAccounting': 'Àwọn Ìjábọ̀ & Ìṣirò Owó',
  'menu.systemAndCommunication': 'Ètò & Ìbánisọ̀rọ̀',
};